<script setup lang="ts">
import InputNumber from '@/components/BaseComponents/InputNumber.vue';
import type { Ingredient } from '@/types/dish';
import Checkbox from 'primevue/checkbox';
import { defineEmits, defineProps, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  ingredient: Ingredient;
}>();

const theIngredient = ref(props.ingredient);

const emit = defineEmits(['toggle', 'update-ingredient']);
const { t, te } = useI18n();

const toggleIngredientSelection = () => {
  emit('toggle', theIngredient.value);
  // emit('update-ingredient', ingredient)
};

const onQuantityChange = () => {
  theIngredient.value.is_selected = true;
  console.log('Update quantity of ingredient', theIngredient.value);
  emit('update-ingredient', theIngredient.value);
};

watch(
  () => props.ingredient,
  (newIngredient) => {
    theIngredient.value = newIngredient;
  },
);
</script>

<template>
  <div class="mb-4 flex w-full gap-3 border-b border-primary-500 pb-1 text-sm text-primary-950">
    <div class="flex w-3 flex-none items-center">
      <Checkbox
        v-model="theIngredient.is_selected"
        :input-id="`checkbox-${theIngredient.id}`"
        :binary="true"
        @click.prevent="() => toggleIngredientSelection()"
      />
    </div>
    <label :for="`checkbox-${theIngredient.id}`" class="flex min-w-0 flex-1 gap-1">
      <div class="w-24 flex-none">
        <div class="flex items-center gap-1 text-left">
          <InputNumber
            v-model="theIngredient.quantity"
            :placeholder="t('profileFavorites.creationForm.quantityPlaceholder')"
            class="w-16 flex-none"
            mode="decimal"
            @input="onQuantityChange"
          />
          <span class="flex-1">
            {{ te(`ingredients.unit.symbol.${theIngredient.unit}`) ? t(`ingredients.unit.symbol.${theIngredient.unit}`) : '' }}
          </span>
        </div>
      </div>
      <div class="flex h-full min-w-0 flex-1 items-center">
        <span class="truncate">{{ theIngredient.name }}</span>
      </div>
      <div class="flex w-10 flex-none items-center">
        <span>{{ theIngredient.price }}</span>
      </div>
    </label>
  </div>
</template>
